import { NgModule } from '@angular/core';
import { ActiconV3dComponentsService } from './v3d-components/acticon-v3d-components.service';
import { Visualize3dModule } from '@magicore/visualize-3d';

/**
 * This module contains Acticon-specific V3D implementations
 */
@NgModule({
  imports: [Visualize3dModule],
  providers: [ActiconV3dComponentsService]
})
export class ActiconVisualize3dModule {}
